export default __webpack_public_path__ + "static/media/polygonlogo.2f48ca1f.svg";